import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import companiesGroupsSlice from '../reducers/companiesGroups.slice'

const persistConfig = {
  key: 'companiesGroupsSlice',
  storage,
}

export const persistedCompaniesGroupsReducer = persistReducer(persistConfig, companiesGroupsSlice)